<template>
  <div>
    <v-form ref="planIdentityForm" v-model="valid">
      <v-container fluid grid-list-md>
        <material-card
          :title="$t('components.plancreationwizard.plan_information')"
          :color="$vuetify.theme.themes.light.secondary"
          icon="info"
        >
          <v-card-text>
            <v-layout row wrap>
              <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
                <tooltip-textbox
                  v-if="edit"
                  :disabled="true"
                  :value.sync="planIdentity.UniqueIdentifier"
                  :label="$t('components.plancreationwizard.unique_identifier')"
                  :rules="[$rules.required]"
                  :tooltipText="
                    $t('views.plangeneralparameters.unique_identifier_tooltip')
                  "
                  class="required"
                ></tooltip-textbox>
                <template v-else>
                  {{ $t("components.plancreationwizard.unique_identifier") }}
                  <br />
                  <span class="minfo">
                    {{ planIdentity.UniqueIdentifier }}
                  </span>
                </template>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
                <trans-field
                  v-if="edit"
                  v-model="planIdentity.Current"
                  :label="$t('globals.name')"
                  field="Name"
                ></trans-field>
                <template v-else>
                  {{ $t("globals.name") }}
                  <br />
                  <span class="minfo">
                    {{ translate2(planIdentity.Current, "Name") }}
                  </span>
                </template>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
                <v-tooltip bottom v-if="edit">
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters>
                        <v-col>
                          <pbas-date-picker
                            :value="planIdentity.PlanEffectiveDate"
                            @update-date="
                              planIdentity.PlanEffectiveDate = $event
                            "
                            :label="
                              $t(
                                'views.plangeneralparameters.plan_effective_date'
                              )
                            "
                            disabled
                          ></pbas-date-picker>
                        </v-col>
                        <v-col
                          style="margin-top:20px;margin-left:3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{ $t("views.plangeneralparameters.date_tooltip") }}
                  </span>
                </v-tooltip>
                <template v-else>
                  {{ $t("views.plangeneralparameters.plan_effective_date") }}
                <br />
                <span class="minfo">
                  {{ formatDate(planIdentity.PlanEffectiveDate) }}
                </span>
                </template>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
                <v-tooltip bottom v-if="edit">
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters>
                        <v-col>
                          <pbas-date-picker
                            :value="planIdentity.Current.EffectiveDate"
                            @update-date="
                              planIdentity.Current.EffectiveDate = $event
                            "
                            :label="
                              $t('components.plancreationwizard.effective_date')
                            "
                            disabled
                          ></pbas-date-picker>
                        </v-col>
                        <v-col
                          style="margin-top:20px;margin-left:3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{
                      $t("views.plangeneralparameters.effective_date_tooltip")
                    }}
                  </span>
                </v-tooltip>
                <template v-else>
                  {{ $t("components.plancreationwizard.effective_date") }}
                <br />
                <span class="minfo">
                  {{ formatDate(planIdentity.Current.EffectiveDate) }}
                </span>
                </template>
              </v-col>
            </v-layout>
            <v-layout row wrap>
              <v-col cols="12" md="6" class="pt-0 pb-0">
                <trans-textarea
                  v-if="edit"
                  v-model="planIdentity.Current"
                  :label="$t('globals.description')"
                  field="Description"
                  :disabled="true"
                ></trans-textarea>
                <template v-else>
                  <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{ $t("globals.description") }}
                <br />
                <span class="minfo">
                  {{ translate2(planIdentity.Current, "Description") }}
                </span>
              </div>
                </template>
              </v-col>
              <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                {{
                  $t("components.plan_builder.pensionsplanbuilder.registered")
                }}
                <br />
                <span class="minfo">
                  {{
                    planIdentity.ProvinceOfRegistration !== null &&
                    planIdentity.ProvinceOfRegistration !== undefined
                      ? $t("globals.yes")
                      : $t("globals.no")
                  }}
                </span>
              </div>
              <!-- <v-col cols="12" md="6" class="pt-0 pb-0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-container pa-0>
                            <v-row no-gutters class="test">
                              <v-col cols="auto">
                                <v-checkbox
                                  :class="$attrs['class']"
                                  v-model="registered"
                                  :label="
                                    $t(
                                      'components.plan_builder.pensionsplanbuilder.registered'
                                    )
                                  "
                                ></v-checkbox>
                              </v-col>
                              <v-col
                                style="margin-top: 20px; margin-left: 3px"
                                cols="auto"
                              >
                                <v-icon v-bind="attrs" v-on="on">help</v-icon>
                              </v-col>
                            </v-row>
                          </v-container>
                        </template>
                        <span>
                          {{
                            $t(
                              "components.plan_builder.pensionsplanbuilder.registered_tooltip"
                            )
                          }}
                        </span>
                      </v-tooltip>
                    </v-col> -->
              <template
                v-if="
                  planIdentity.ProvinceOfRegistration !== null &&
                    planIdentity.ProvinceOfRegistration !== undefined
                "
              >
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{
                    $t(
                      "components.plan_builder.pensionsplanbuilder.province_of_registration"
                    )
                  }}
                  <br />
                  <span class="minfo">
                    {{
                      translate2(
                        planIdentity.ProvinceOfRegistration,
                        "DisplayValue"
                      )
                    }}
                  </span>
                  <!-- <trans-select
                      :item="generalSettings.PlanSettings"
                      propertyName="ProvinceOfRegistration"
                      :items="options.Models.Province"
                      :label="
                        $t(
                          'components.plan_builder.pensionsplanbuilder.province_of_registration'
                        )
                      "
                      :rules="[$rules.required]"
                      class="required"
                    ></trans-select> -->
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{
                    $t(
                      "components.plan_builder.pensionsplanbuilder.provincial_registration_number"
                    )
                  }}
                  <br />
                  <span class="minfo">
                    {{ planIdentity.ProvincialRegNo }}
                  </span>
                  <!-- <no-autocomplete-textfield
                      v-model="
                        generalSettings.PlanSettings
                          .ProvincialRegistrationNumber
                      "
                      :label="
                        $t(
                          'components.plan_builder.pensionsplanbuilder.provincial_registration_number'
                        )
                      "
                      :clearable="true"
                      :rules="[$rules.alphanumeric, $rules.dynamic.length(6)]"
                    ></no-autocomplete-textfield> -->
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{
                    $t(
                      "components.plan_builder.pensionsplanbuilder.cra_registration_number"
                    )
                  }}
                  <br />
                  <span class="minfo">
                    {{ planIdentity.CRARegNo }}
                  </span>
                  <!-- <no-autocomplete-textfield
                      v-model="
                        generalSettings.PlanSettings.CRARegistrationNumber
                      "
                      :label="
                        $t(
                          'components.plan_builder.pensionsplanbuilder.cra_registration_number'
                        )
                      "
                      :clearable="true"
                      :rules="[$rules.integer, $rules.dynamic.length(7)]"
                    ></no-autocomplete-textfield> -->
                </div>
              </template>
            </v-layout>
          </v-card-text>
        </material-card>
        <material-card
          :title="$t('components.plancreationwizard.plan_settings')"
          :color="$vuetify.theme.themes.light.secondary"
          icon="settings"
          style="margin-top:30px"
        >
          <v-card-text>
            <v-layout row wrap>
              <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                <v-checkbox
                  v-if="edit"
                  v-model="hasClasses"
                  :label="$t('components.plancreationwizard.has_classes')"
                  disabled
                ></v-checkbox>
                <template v-else>
                  {{ $t("components.plancreationwizard.has_classes") }}
                  <br />
                  <span class="minfo">
                    {{ hasClasses ? $t("globals.yes") : $t("globals.no") }}
                  </span>
                </template>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                v-if="hasClasses"
                class="pt-0 pb-0"
              >
                <v-tooltip bottom v-if="edit">
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters>
                        <v-col>
                          <v-combobox
                            :value="classesStr.split(',').filter((e) => e)"
                            @input="
                              classesStr = $event.filter((e) => e).join(',')
                            "
                            hide-selected
                            :label="$t('components.plancreationwizard.classes')"
                            multiple
                            small-chips
                            disabled
                          >
                            <template
                              v-slot:selection="{
                                attrs,
                                item,
                                parent,
                                selected,
                              }"
                            >
                              <v-chip
                                v-bind="attrs"
                                color="primary"
                                :input-value="selected"
                                label
                                small
                              >
                                <span class="pr-2">
                                  {{ item }}
                                </span>
                                <v-icon small @click="parent.selectItem(item)">
                                  close
                                </v-icon>
                              </v-chip>
                            </template>
                          </v-combobox>
                        </v-col>
                        <v-col
                          style="margin-top:20px;margin-left:3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{ $t("views.plangeneralparameters.classes_tooltip") }}
                  </span>
                </v-tooltip>
                <template v-else>
                  {{ $t("components.plancreationwizard.classes") }}
                  <br />
                  <span class="minfo">
                    {{ classesStr }}
                  </span>
                </template>
              </v-col>
            </v-layout>
          </v-card-text>
        </material-card>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PeriodPicker from "@/components/PeriodPicker";
import DuePicker from "@/components/DuePicker";
import ErrorHandler from "@/components/ErrorHandler";
import TransSelect from "@/components/TransSelect";
import TransField from "@/components/TransField";
import TooltipTextbox from "@/components/TooltipTextbox";
import TransTextbox from "@/components/TransTextbox";
import TransTextarea from "@/components/TransTextarea";
import ImageUploaderString from "@/components/ImageUploaderString";
import AutoSelect from "@/components/AutoSelect";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { translate2 } from "@/trans2";

export default {
  components: {
    ErrorHandler,
    PeriodPicker,
    DuePicker,
    TransSelect,
    TransField,
    TooltipTextbox,
    TransTextbox,
    TransTextarea,
    ImageUploaderString,
    AutoSelect,
    NoAutocompleteTextfield,
  },
  props: ["originalItem", "edit"],
  data() {
    return {
      hasClasses: false,
      error: null,
      saving: false,
      valid: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      planIdentity: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "winZones"]),
    ...mapGetters("auth", ["isLoggedIn", "user"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
  },
  watch: {
    originalItem: {
      handler() {
        this.initialize();
      },
    },
    "planIdentity.PlanDetails.Status": {
      handler(v) {
        if (v) {
          this.planIdentity.PlanDetails.StatusId = this.planIdentity.PlanDetails.Status.Id;
        } else {
          this.planIdentity.PlanDetails.StatusId = null;
        }
      },
    },
    "planIdentity.PlanDetails.Term.TimeUnit": {
      handler(v) {
        //console.log("Term.TimeUnit: ", v);
        if (v) {
          if (v === "Week" || v === "Day") {
            this.planIdentity.PlanDetails.DueDate.DueTimeUnit = "Week";
          }
        }
      },
    },
  },
  async mounted() {
    if (this.originalItem !== null && this.originalItem !== undefined) {
      this.initialize();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["updatePlan"]),
    async initialize() {
      this.planIdentity = JSON.parse(JSON.stringify(this.originalItem));

      if (this.planIdentity && this.planIdentity.Current.Classes) {
        this.hasClasses = true;
        this.classesStr = this.planIdentity.Current.Classes.replace(/\[/g, "")
          .replace(/\]/g, "")
          .replace(/"/g, "");
      }
    },
    async save() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.planIdentity));
        delete item["@odata.context"];
        await this.updatePlan(item);
        this.originalItem = JSON.parse(JSON.stringify(this.planIdentity));
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.$emit("saved");
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    translate2(item, field) {
      return translate2(item, field);
    },
  },
};
</script>

<style>
.full-width {
  width: 100%;
}
.padding-top-14 {
  padding-top: 14px !important;
}
.padding-top-17 {
  padding-top: 17px !important;
}
</style>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
